module.exports = __webpack_public_path__ + "img/check-bold-white.694f7ec4.svg";